module.exports = __webpack_public_path__ + "static/media/iphone 12 pro max banner6.19f63b24.jpg";